import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { SwiperConfigInterface, SwiperDirective } from 'ngx-swiper-wrapper';
import { Subscription } from 'rxjs';
import { AlertsService } from 'src/app/services/alerts/alerts.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { CartService } from 'src/app/services/cart/cart.service';
import { ProductsService } from 'src/app/services/products/products.service';
import { PromotionsService } from 'src/app/services/promotions/promotions.service';
import { StoresService } from 'src/app/services/stores/stores.service';
import { ModalService } from 'src/app/services/modal/modal.service';
import { CartModalComponent } from 'src/app/components/cartModal/cart-modal/cart-modal.component';
import { CheckoutService } from 'src/app/services/checkout/checkout.service';
import { DomSanitizer, Title, Meta } from '@angular/platform-browser';


import { GtmService } from 'src/app/services/gtm/gtm.service';
import { productHasAnySellableStock } from 'src/app/utils/product-stock.util';



@Component({
  selector: 'app-product-card',
  templateUrl: './product-card.component.html',
  styleUrls: ['./product-card.component.css']
})
export class ProductCardComponent implements OnInit {
  @Input() product:any = {}
  @Input() category:string = ''
  @Input() catalogo: boolean = false
  default_image : string = "https://puu.sh/ImNRs/0ab1b352dc.png";
  id_store_current : string
  promoActive: boolean = false
  isAuth: boolean = false
  public promotionInfo : any = [];

  @ViewChild(SwiperDirective, { static: false }) directiveRef?: SwiperDirective;
  // default
  public swiperDefaultConfig: SwiperConfigInterface = {};
  // config swiper
  public swiperAutoplayConfig: SwiperConfigInterface = {
    spaceBetween: 10,
    slidesPerView: 1,
    centeredSlides: false,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },

      // FIN puntos responsive
  };
  variation:any = {}
  private subscriptions: Array<Subscription> = [];
  cart:any[] = []

  slugName:string

  nameProduct:string

  buyNow:boolean = false

  hideBtnBuyNow:boolean = true


  showSecondaryImage:boolean = false

  logoProduct:string = ''
  
  tagsList : any = [];

  get isFullyOutOfStock(): boolean {
    return !productHasAnySellableStock(this.product);
  }

  constructor(
    private stores: StoresService,
    private cartService: CartService,
    private PromotionsServices: PromotionsService,
    private productService: ProductsService,
    private auth: AuthService,
    private router: Router,
    private spinner: NgxSpinnerService,
    private alerts: AlertsService,
    private translate: TranslateService,
    private modalService: ModalService<CartModalComponent>,
    private checkoutService: CheckoutService,
    private sanitizer: DomSanitizer,
		private gtmService: GtmService

  ) {
    this.checkAuth()
    this.getId()
  }

  ngOnInit(): void {
    this.getPromos()
    this.getCart()
    
    this.product.variants.length > 0 && ( this.variation = ( this.product.variants.find(v => v.stock > 0) ? this.product.variants.find(v => v.stock > 0) : this.product.variants[0] ) )  
    // console.warn(this.product,'producto',this.variation)
    // this.product.images = [{url:'https://http2.mlstatic.com/D_NQ_NP_979362-MLA31015424549_062019-O.jpg'}] //test si muestra la imagen general
    
    if(this.product.variants[0].tags.length > 0){
      this.product.variants[0].tags.map(tagItem=>{
        this.tagsList.push(tagItem.tag.name)
      })
    }
    

   this.nameProduct = this.product.name
    if(this.product.variants.length > 0 && this.product.name == null || this.product.name == undefined){
      this.nameProduct = this.product.variants[0].name
    }
    this.slugName = this.nameProduct.replace(/-/g,'_') //reemplazo guion por _
                    .replace(/\s-\s/g,'-_-') //reemplazo guion con espacio de cada lado por _
                    .replace(/\s/g, '-') //reemplazo espacio en blanco por guion
                    .replace(/\+/g,'¬') // reemplazo + por ¬ 
                    .replace(/\//g,'\\') // reemplazo / por \

    if(this.product.variants.length > 0){
      let toppings = this.product.variants[0].toppings
      if(toppings.length > 0){
        let {topping } = toppings[0]
        if(topping.length > 0){
          this.logoProduct = topping[0].image
        }
      }



      
      
      if(!this.product.images || this.product.images.length == 0){
        this.product.images = this.product.variants[0].images
      }

      this.product.images = this.product.images.map(image => {
        if (image && image.url) {
          const parts = image.url.split('.');
            const extension = parts.pop();
            const baseName = parts.join('.');
            if(baseName.includes('compress')){
              return { ...image, url: image.url };
            }
            return { ...image, url: `${baseName}compress.${extension}` };
        }
        return image;
      });


      if (this.product && Array.isArray(this.product.variants)) {
        this.product.variants = this.product.variants.map(variant => {
          if (variant && Array.isArray(variant.images) && variant.images.length > 0) {
            variant.images = variant.images.map(image => {
              if (image && image.url) {
                const parts = image.url.split('.');
                const extension = parts.pop();
                const baseName = parts.join('.');
                if(baseName.includes('compress')){
                  return { ...image, url: image.url };
                }
                return { ...image, url: `${baseName}compress.${extension}` };
              }
              return image; 
            });

          }
          return variant; 
        });
      }



      // console.log('this.product.images',this.product.images)

    }
    this.product.hovering = false
  }


  showSeconImage() {
    this.showSecondaryImage = true;
  }

  hideSeconImage() {
    this.showSecondaryImage = false;
  }

  processHTML(html: string) {
    // Create a temporary DOM element to manipulate the HTML
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;

    // Add 'truncate' class to all <p> elements
    const paragraphs: NodeListOf<HTMLParagraphElement> = tempDiv.querySelectorAll('p');
    paragraphs.forEach((p: HTMLParagraphElement) => {
      p.classList.add('truncate');
    });

    // Return the sanitized HTML
    return this.sanitizer.bypassSecurityTrustHtml(tempDiv.innerHTML);
  }

  ngOnDestroy(){
    this.variation = {}
    this.subscriptions.forEach((subscription: Subscription) => subscription.unsubscribe());
  }
  

  getConfigStore(){
    this.stores.getAllConfig()
    .subscribe((config:any[]) => {
      config.map(({name, value}) => {
        if(name === 'hide-btnbuynow'){
          this.hideBtnBuyNow =  value === 'true';
        }
      })
    })
  }



  getCart(){
    this.subscriptions.push(
     this.cartService.getCart().subscribe(cart => this.cart = cart )
    )
  }

  getId(){
    this.stores.getStoreId()
    .subscribe(id => id !== null && id !== "null" ? this.id_store_current = id : null )
  }

  checkAuth(){
    this.auth.isAuthenticated() && (this.isAuth = true)
    this.getConfigStore()
  }

  getPromos(){
    let _this = this;
    this.PromotionsServices.getPromotion().subscribe((promotion : any) => {
    this.PromotionsServices.getPromotion()
      if(promotion){
        this.promotionInfo = promotion;
        if(this.promotionInfo&&this.promotionInfo!=false && (this.promotionInfo.type=='004' || this.promotionInfo.type=='002' || this.promotionInfo.type=='005' )){
          this.PromotionsServices.isProductInPromotion(this.id_store_current,this.product.sku).then((res2) => {
            if (res2.state == "success") {
                if(res2.data.length!=0){
                  _this.promoActive=  true;
                    }else{
                      _this.promoActive=  false;
                    }
                  }else{
                    _this.promoActive=  false;
                }
          }).catch((error) => {
            _this.promoActive=  false;
            });
       }
      }

    });
  }

  redirect(sku:any) {
    // this.slugName = sku.variants[0].name.replace(/-/g,'_').replace(/\s/g, '-')
    this.category !== '' && this.productService.setCategory(this.category)
   
    this.router.navigate([`/${this.id_store_current}/product/${this.slugName}`])
    // !this.isAuth ? this.router.navigate([`/home/product/${sku}`]) : this.router.navigate([`/home/wholesales/product/${sku}`])
  }

  async getDetail(){
    this.spinner.show()
    try {
      let {data: prod} = await this.productService.getProductBySku(this.product.sku, this.id_store_current, false)
      this.cartService.addItemTocart(prod, 1)
      this.alerts.alertToastCenter(this.translate.instant('checkout.productoAdd'))
      this.spinner.hide()
    } catch (error) {
      this.spinner.hide()
      this.alerts.alertError('Ha ocurrido un error, intente nuevamente')
    }
  }

  addToCart(){
    this.variation['image'] = this.variation.images.length > 0 ? this.variation.images[0].url : ''
    if(this.variation.stock === 0) return this.alerts.alertError(this.translate.instant('alerts.noStockAvailable')) 
    else this.addItemTocart()
  }

  async addItemTocart() {
    let exist = false;
    for (var i = 0; i < this.cart.length; i++) {
      if (this.cart[i].variation.product_sku == this.variation.product_sku) {
        if ((this.cart[i].variation.quantity + 1) <= this.variation.stock) {
          exist = true;
          const nameVariant = this.variation.variants_options && this.variation.variants_options.length > 0
            ? `${this.variation.variants_options[0].name} - ${this.variation.variants_options[0].value}`
            : '';
			    this.gtmService.addToCart(this.variation.product_sku, this.variation.name, this.variation.price, 1, nameVariant);

          this.cartService.addItemTocart(this.product, this.variation, 1);
        
          if(!this.buyNow){
            this.alerts.alertToastCenter(this.translate.instant('checkout.productoAdd'))
          }else{
            this.buyNow = false
            this.openCheckout()
          }
        } else {
          this.alerts.alertError(this.translate.instant('alerts.cantidadExcede'))
        }
        return;
      }
    }
    if (!exist) {
      this.cartService.addItemTocart(this.product, this.variation, 1);
      const nameVariant = this.variation.variants_options && this.variation.variants_options.length > 0
        ? `${this.variation.variants_options[0].name} - ${this.variation.variants_options[0].value}`
        : '';
      this.gtmService.addToCart(this.variation.product_sku, this.variation.name, this.variation.price, 1, nameVariant);
    
      if(!this.buyNow){
        this.alerts.alertToastCenter(this.translate.instant('checkout.productoAdd'))
        this.cartService.setShowCheckout(false);
        this.checkoutService.setIsSub(false);
      }else{
        this.buyNow = false
        this.openCheckout()
      }
    }
  }
  
 
  async openCheckout(): Promise<void> {
    this.cartService.setShowCheckout(true);
		this.checkoutService.setIsSub(false);
		 sessionStorage.setItem('allowCheckout', 'true');

		this.router.navigate([`/${this.id_store_current}/checkout`]);
    return
    const {CartModalComponent} = await import(
      '../../components/cartModal/cart-modal/cart-modal.component'
    );

    await this.modalService.open(CartModalComponent);
    this.modalService.nameComponent.next('CartModalComponent')
    this.cartService.setShowCheckout(true);
    this.checkoutService.setIsSub(false);
  }

}
